import type { AdminQualityBand } from "../modules/types";
import { adminApiGet } from "./utils";

export const adminQualityBandsApi = {
  getAll: (workspaceId?: string): Promise<AdminQualityBand[]> =>
    adminApiGet<AdminQualityBand[]>(
      workspaceId
        ? `/quality_bands?workspace_id=${encodeURIComponent(workspaceId)}`
        : "/quality_bands",
    ),

  getById: (id: string): Promise<AdminQualityBand> =>
    adminApiGet<AdminQualityBand>(`/quality_bands/${id}`),
};
